<template>
    <section class="invoice-preview-wrapper mt-1">
      <b-button
        id="btn-print"
        ref="btnprint"
        variant="primary"
        size="sm"
        style="
          margin-right: 1%;
          background: #0056b3 !important;
          border-color: #0056b3 !important;
          color: #fff;
        "
        @click="printInvoice"
      >
        <feather-icon
          icon="PrinterIcon"
          size="16"
          class="align-text-top"
        />
      </b-button>
      <b-row
        class="invoice-preview"
      >
  
        <!-- Col: Left (Invoice Container) -->
        <b-col
          cols="12"
          xl="12"
          md="8"
        >
          <b-card
            no-body
            class="invoice-preview-card"
          >
            <!-- Header -->
            <b-card-body class="invoice-padding pb-0">
  
              <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
  
                <!-- Header: Left Content -->
                <div>
                  <div class="logo-wrapper">
                    <!-- <logo /> -->
                    <b-img
                    :src="appLogoLobitozz"
                    alt="logo"
                    width="50%"
                    />
                    <h3 class="text-primary invoice-logo">
                      Lobitozz
                    </h3>
                  </div>
                  <p class="card-text mb-25">
                    Aeropuerto Baltra, Galápagos Ecuador.
                  </p>
                  <p class="card-text mb-25">
                    ventasgrupo@lobitogalapagos.com
                  </p>
                  <p class="card-text mb-0">
                    +593 967549023
                  </p>
                </div>
  
                <!-- Header: Right Content -->
                <div class="mt-md-0 mt-2">
                  <h4 class="invoice-title">
                    Factura
                    <span class="invoice-number"># {{ this.factura.numero_documento }}</span>
                  </h4>
                  <div class="invoice-date-wrapper">
                    <p class="invoice-date-title">
                      Fecha emisión:
                    </p>
                    <p class="invoice-date">
                      {{ new Date(this.factura.fecha_emision).toLocaleString("pt-BR") }}
                    </p>
                  </div>
                  <div class="invoice-date-wrapper">
                    <p class="invoice-date-title">
                      Fecha creación:
                    </p>
                    <p class="invoice-date">
                      {{ new Date(this.factura.fecha_creacion).toLocaleString("pt-BR") }}
                    </p>
                  </div>
                </div>
              </div>
            </b-card-body>
  
            <!-- Spacer -->
            <hr class="invoice-spacing">
  
            <!-- Invoice Client & Payment Details -->
            <b-card-body
              class="invoice-padding pt-0"
            >
              <b-row class="invoice-spacing">
  
                <!-- Col: Invoice To -->
                <b-col
                  cols="12"
                  xl="6"
                  class="p-0"
                >
                  <h6 class="mb-2">
                    Facturar a:
                  </h6>
                  <h6 class="mb-25">
                     {{ this.factura.cliente.razon_social }}
                  </h6>
                  <p class="card-text mb-25">
                    {{ this.factura.cliente.cedula }}
                  </p>
                  <p class="card-text mb-25">
                    {{ this.factura.cliente.direccion }}
                </p>
                <p class="card-text mb-25">
                      Tlf. {{ this.factura.cliente.telefonos }}
                  </p>
                  <p class="card-text mb-0">
                    {{this.factura.cliente.email}}
                  </p>
                </b-col>
  
                <!-- Col: Payment Details -->
                <b-col
                  xl="6"
                  cols="12"
                  class="p-0 mt-xl-0 mt-2 d-flex justify-content-xl-end"
                >
                  <div>
                    <h6 class="mb-2">
                        Detalles del pago:
                    </h6>
                    <table>
                      <tbody>
                        <tr>
                          <td class="pr-1">
                            Total adeudado:
                          </td>
                          <td><span class="font-weight-bold">{{ this.factura.total | formattedDollars }}</span></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </b-col>
              </b-row>
            </b-card-body>
  
            <!-- Invoice Description: Table -->
            <b-table-lite
              responsive
              :items="this.factura.detallefacturaSet"
              :fields="['detalle', 'cantidad', 'precio_unitario', 'subtotal']"
            >
              <template #cell(precio_unitario)="data">
                <b-card-text class="font-weight-bold mb-25 text-right">
                  {{ data.item.precio_unitario | formattedDollars }}
                </b-card-text>
              </template>
              <template #cell(subtotal)="data">
                <b-card-text class="font-weight-bold mb-25 text-right">
                  {{ data.item.subtotal | formattedDollars }}
                </b-card-text>
              </template>
            </b-table-lite>
  
            <!-- Invoice Description: Total -->
            <b-card-body class="invoice-padding pb-0">
              <b-row>
  
                <!-- Col: Sales Persion -->
                <b-col
                  cols="12"
                  md="6"
                  class="mt-md-0 mt-3"
                  order="2"
                  order-md="1"
                >
                  <b-card-text class="mb-0">
                    <span class="font-weight-bold">Descripción:</span>
                    <span class="ml-75"> {{ this.factura.descripcion }}</span>
                  </b-card-text>
                </b-col>
  
                <!-- Col: Total -->
                <b-col
                  cols="12"
                  md="6"
                  class="mt-md-6 d-flex justify-content-end"
                  order="1"
                  order-md="2"
                >
                  <div class="invoice-total-wrapper">
                    <div class="invoice-total-item">
                      <p class="invoice-total-title">
                        Subtotal:
                      </p>
                      <p class="invoice-total-amount">
                        {{ this.factura.subtotal_0 | formattedDollars }}
                      </p>
                    </div>
                    <div class="invoice-total-item">
                      <p class="invoice-total-title">
                        Descuento:
                      </p>
                      <p class="invoice-total-amount">
                        $0.00
                      </p>
                    </div>
                    <div class="invoice-total-item">
                      <p class="invoice-total-title">
                        Iva:
                      </p>
                      <p class="invoice-total-amount">
                        {{ this.factura.iva | formattedDollars }}
                      </p>
                    </div>
                    <hr class="my-50">
                    <div class="invoice-total-item">
                      <p class="invoice-total-title">
                        Total:
                      </p>
                      <p class="invoice-total-amount">
                        {{ this.factura.total | formattedDollars }}
                      </p>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-card-body>
  
            <!-- Spacer -->
            <hr class="invoice-spacing">
  
            <!-- Note -->
            <b-card-body class="invoice-padding pt-0">
              <span class="font-weight-bold">Nota: </span>
              <span>Agradecemos su preferencia. Quedamos a su disposición para cualquier consulta o necesidad futura. ¡Gracias por su compra!</span>
            </b-card-body>
          </b-card>
        </b-col>
  
        <!-- Right Col: Card -->
        <!-- <b-col
          cols="12"
          md="4"
          xl="3"
          class="invoice-actions"
        >
          <b-card> -->
  
            <!-- Button: Print -->
            <!-- <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              class="mb-75"
              block
              @click="printInvoice"
            >
              Print
            </b-button> -->
  
          <!-- </b-card>
        </b-col> -->
      </b-row>
    </section>
  </template>
  
  <script>
  import {
    BRow, BCol, BCard, BCardBody, BTableLite, BCardText, BButton, BAlert, BLink, VBToggle, BImg,
  } from 'bootstrap-vue'
  import Logo from '@core/layouts/components/Logo.vue'
  import Ripple from 'vue-ripple-directive'
  import axios from "@axios";
import { ThumbsDownIcon } from 'vue-feather-icons'
import { $themeConfig } from '@themeConfig'
import $ from "jquery";

  
  export default {
    directives: {
      Ripple,
      'b-toggle': VBToggle,
    },
    components: {
      BRow,
      BCol,
      BCard,
      BCardBody,
      BTableLite,
      BCardText,
      BButton,
      BAlert,
      BLink,
      BImg,
  
      Logo,
    },
    created() {
    // this.comprobarPermisos();
        $("#btn-excel").remove();
        $("#btn-pdf").remove();
        $("#eliminar-viajes").remove();
        $("#btn-abrir-caja").remove();
    },
    data(){
        return {
            factura: {
                cliente: {
                    razon_social: '',
                    cedula: '',
                    direccion: '',
                    telefonos: '',
                    email: ''
                },
                detallefacturaSet: [],
                numero_documento: '',
                fecha_emision: '',
                fecha_creacion: '',
                descripcion: '',
                subtotal_0: 0,
                iva: 0,
                total: 0
            }
        }
    },
    mounted(){
        if (this.$route.params.tokenFactura) {
            this.token = this.$route.params.tokenFactura;
            this.getFactura();
        } else {
            actions.setearTitulo("");
        }
        $("#contenedor-botones")
        .append($("#btn-print"))
    },
    methods: {
        comprobarPermisos() {
          if (
            localStorage.getItem("permisos").indexOf("ord_factura_consultar") === -1
          ) {
            this.$router.push({ name: "not-permitted" });
          }
        },
        getFactura() {
        axios
            .post("api", {
            query: `query getFactura($tokenFactura: String!){
                    getFactura(tokenFactura:$tokenFactura){
                        factura{
                            fecha_emision: fechaEmision
                            fecha_creacion: fechaCreacion
                            cliente{
                                razon_social: razonSocial
                                cedula
                                direccion
                                telefonos
                                email
                            }
                            estado
                            numero_documento: numeroDocumento
                            descripcion
                            subtotal_0: subtotal0
                            total
                            iva
                            detallefacturaSet{
                                cantidad
                                base_cero: baseCero
                                detalle
                                precio_unitario: precioUnitario
                                subtotal
                            }
                        }
                        status,
                        message
                    }
                }`,
            variables: {
                tokenFactura: this.$route.params.tokenFactura,
            },
            })
            .then((response) => {
            if (response.status === 200) {
                if (response.data.data.getFactura.status === "success") {
                    const datos = response.data.data.getFactura.factura;
                    this.factura = datos
                } else {
                    this.$router.push({ name: "error-404" });
                }
            }
            });
        },
    },
    setup() {
    //   const invoiceData = ref(null)
    //   const paymentDetails = ref({})
  
    //   // Invoice Description
    //   // ? Your real data will contain this information
    //   const invoiceDescription = [
    //     {
    //       taskTitle: 'Native App Development',
    //       taskDescription: 'Developed a full stack native app using React Native, Bootstrap & Python',
    //       rate: '$60.00',
    //       hours: '30',
    //       total: '$1,800.00',
    //     },
    //     {
    //       taskTitle: 'UI Kit Design',
    //       taskDescription: 'Designed a UI kit for native app using Sketch, Figma & Adobe XD',
    //       rate: '$60.00',
    //       hours: '20',
    //       total: '$1200.00',
    //     },
    //   ]
  
    //   const INVOICE_APP_STORE_MODULE_NAME = 'app-invoice'
  
    //   // Register module
    //   if (!store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) store.registerModule(INVOICE_APP_STORE_MODULE_NAME, invoiceStoreModule)
  
    //   // UnRegister on leave
    //   onUnmounted(() => {
    //     if (store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) store.unregisterModule(INVOICE_APP_STORE_MODULE_NAME)
    //   })
  
    //   store.dispatch('app-invoice/fetchInvoice', { id: router.currentRoute.params.id })
    //     .then(response => {
    //       invoiceData.value = response.data.invoice
    //       paymentDetails.value = response.data.paymentDetails
    //     })
    //     .catch(error => {
    //       if (error.response.status === 404) {
    //         invoiceData.value = undefined
    //       }
    //     })
    const {
     appLogoLobitozz,
    } = $themeConfig.app
  
      const printInvoice = () => {
        window.print()
      }
  
      return {
        // invoiceData,
        // paymentDetails,
        // invoiceDescription,
        appLogoLobitozz,
        printInvoice,
      }
    },
  }
  </script>
  
  <style lang="scss" scoped>
  @import "~@core/scss/base/pages/app-invoice.scss";
  </style>
  
  <style lang="scss">
  @media print {
  
    // Global Styles
    body {
      background-color: transparent !important;
    }
    nav.header-navbar {
      display: none;
    }
    .main-menu {
      display: none;
    }
    .header-navbar-shadow {
      display: none !important;
    }
    .content.app-content {
      margin-left: 0;
      padding-top: 2rem !important;
    }
    footer.footer {
      display: none;
    }
    .card {
      background-color: transparent;
      box-shadow: none;
    }
    .customizer-toggle {
      display: none !important;
    }
  
    // Invoice Specific Styles
    .invoice-preview-wrapper {
      .row.invoice-preview {
        .col-md-8 {
          max-width: 100%;
          flex-grow: 1;
        }
  
        .invoice-preview-card {
          .card-body:nth-of-type(2) {
            .row {
                > .col-12 {
                max-width: 50% !important;
              }
  
              .col-12:nth-child(2) {
                display: flex;
                align-items: flex-start;
                justify-content: flex-end;
                margin-top: 0 !important;
              }
            }
          }
        }
      }
  
      // Action Right Col
      .invoice-actions {
        display: none;
      }
    }
  }
  </style>
  